module.exports = __webpack_public_path__ + "static/media/lumbering8.f72198ac.jpg";